export default __webpack_public_path__ + "static/media/arangement-alternate.fe038689.PNG";